export default () => (
  <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M54.1682 49.4545V25.925C54.1682 24.0685 52.6632 22.5636 50.8068 22.5636H44.0841M13.8318 49.4545V25.925C13.8318 24.0685 15.3368 22.5636 17.1932 22.5636H23.9159"
      stroke="#CDDBF6"
      strokeWidth="1.275"
    />
    <path
      d="M18.0305 40.4692C18.269 38.8954 19.2612 37.5374 20.6881 36.832L29.2502 32.599L34 36.3744L38.7497 32.599L47.3119 36.832C48.7387 37.5374 49.731 38.8954 49.9695 40.4692L50.5107 44.0411C50.6665 45.0697 49.8702 45.9957 48.8298 45.9957H19.1702C18.1298 45.9957 17.3335 45.0697 17.4893 44.0411L18.0305 40.4692Z"
      fill="#8FB4FF"
    />
    <rect x="26.9363" y="13.6" width="14.1275" height="17.7811" rx="7.06373" fill="#8FB4FF" />
    <path
      d="M9.35001 49.4545H27.2773V51.6954H34H40.7227V49.4545H58.65V51.6954C58.65 53.5519 57.1451 55.0568 55.2886 55.0568H12.7114C10.8549 55.0568 9.35001 53.5519 9.35001 51.6954V49.4545Z"
      fill="#CDDBF6"
    />
  </svg>
)
